// components/ExportReportModal.js
import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormControl,
  FormLabel,
  Select,
} from '@chakra-ui/react';

const ExportReportModal = ({ isOpen, onClose, onDownload }) => {
  const [fileType, setFileType] = useState('csv'); // Varsayılan olarak CSV

  const handleDownloadClick = () => {
    onDownload(fileType);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Export Report</ModalHeader>
        <ModalBody>
          <FormControl>
            <FormLabel>File Type</FormLabel>
            <Select
              value={fileType}
              onChange={e => setFileType(e.target.value)}
            >
              <option value="csv">CSV</option>
              <option value="xlsx">XLSX</option>
            </Select>
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="blue" onClick={handleDownloadClick} ml={3}>
            Download Report
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ExportReportModal;
